import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../services/auth.service';
import { UsuarioSeguranca } from '../../../models/auth.model';
import { ErrorModel } from '../../../models/error.model';
import { ConfirmDialogComponent } from '../../modal/confirm-dialog/confirm-dialog';

@Component({
  selector: 'app-permissoes-usuario',
  standalone: true,
  imports: [CommonModule, FormsModule, ConfirmDialogComponent],
  templateUrl: './permissoes-usuario.component.html',
  styleUrls: ['./permissoes-usuario.component.css']
})
export class PermissoesUsuarioComponent implements OnInit {
  usuarios: UsuarioSeguranca[] = [];
  filteredUsuarios: UsuarioSeguranca[] = [];
  paginatedUsuarios: UsuarioSeguranca[] = [];

  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;
  pages: number[] = [];

  searchTerm = '';
  confirmDialogAberto = false;
  usuarioParaExcluir: number | null = null;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadUsuarios();
  }

  loadUsuarios(): void {
    this.authService.getUsuarios().subscribe({
      next: (data) => {
        this.usuarios = data;
        this.filteredUsuarios = data;
        this.refreshPagination();
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao carregar usuários.');
      }
    });
  }

  search(): void {
    const termo = this.searchTerm.toLowerCase();
    this.filteredUsuarios = this.usuarios.filter(u =>
      u.nomeCompleto.toLowerCase().includes(termo) ||
      u.nomeUsuario.toLowerCase().includes(termo) ||
      u.email.toLowerCase().includes(termo)
    );
    this.refreshPagination();
  }

  gerenciarPermissoes(id: number): void {
    this.router.navigate(['/home', 'sistema-permissoes-manutencao', id]);
  }

  novoUsuario(): void {
    this.router.navigate(['/home', 'sistema-usuario-admin-manutencao']);
  }

  editarUsuario(id: number): void {
    this.router.navigate(['/home', 'sistema-usuario-admin-manutencao', id]);
  }

  excluirUsuario(id: number): void {
    this.usuarioParaExcluir = id;
    this.confirmDialogAberto = true;
  }

  onConfirmarExclusao(): void {
    this.confirmDialogAberto = false;
    if (this.usuarioParaExcluir == null) return;

    this.authService.deleteUsuario(this.usuarioParaExcluir).subscribe({
      next: () => {
        this.usuarioParaExcluir = null;
        this.toastr.success('Usuário excluído com sucesso.');
        this.loadUsuarios();
      },
      error: (error) => {
        this.usuarioParaExcluir = null;
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao excluir usuário.');
      }
    });
  }

  onCancelarExclusao(): void {
    this.confirmDialogAberto = false;
    this.usuarioParaExcluir = null;
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.updatePagedData();
  }

  private refreshPagination(): void {
    this.totalPages = Math.max(1, Math.ceil(this.filteredUsuarios.length / this.itemsPerPage));
    this.currentPage = 1;
    this.updatePagedData();
    this.updatePageNumbers();
  }

  private updatePagedData(): void {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    this.paginatedUsuarios = this.filteredUsuarios.slice(start, start + this.itemsPerPage);
    this.updatePageNumbers();
  }

  private updatePageNumbers(): void {
    this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }
}
